(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.migration', {
            parent: 'admin',
            url: '/migration',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();
